/* eslint 'no-self-assign': "off",'no-redeclare': 'off',eqeqeq: 'off'  */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, FormGroup, Label, Table, Button, Modal} from 'reactstrap';
import DeleteIcon from '../../../../Assets/images/Icons__trash2.svg';
import classnames from 'classnames';
import { GetPreventativeMaintenanceTemplates,OpenAddTemplatePopup,DeletePMTemplate } from 'action/workorderAction';
import DeleteConfirmation from './WorkOrderDeleteConfirmation';

const headinglabel = {
    fontfamily: 'Lato',
    fontSize: '14px',
    fontWeight: 'bold',
    'margin-left':'15px'
};


class PreventativeMaintenanceTemplates extends Component {

    
    constructor(props) {
        super(props);
        this.state = {
            sort: {
                column: null,
                direction: [
                    { name: 'name', direction: 'asc', onclick: true },
                    { name: 'estimatedTime', direction: 'desc', onclick: false },
                    { name: 'description', direction: 'desc', onclick: false },
                    { name: 'partsTools', direction: 'desc', onclick: false },
                    { name: 'tasks', direction: 'desc', onclick: false },
                ]
            },
            Options_List_Value : {},
            deleteTemplateId: 0, 
            deleteModal: false,      
        };
      
    }

    componentWillMount(){
        this.props.GetPreventativeMaintenanceTemplates();
    }

    componentWillReceiveProps(nextProps){
        if(this.props !== nextProps && nextProps.getTemplates !== undefined && nextProps.getTemplates !== null)
        {
            var fieldsFromDB = nextProps.getTemplates;
            var Options_List_Value = {};
            
            var Options_List_Value = fieldsFromDB.map(el => ({
                templateId: el.templateId,
                name: (el.name !== null && el.name !== "" & el.name !== undefined) ? el.name.substring(0, 30) + (el.name.length > 30 ? "..." : "") : "---",
                description:(el.description !== null && el.description !== "" & el.description !== undefined) ? el.description.substring(0, 30) + (el.description.length > 30 ? "..." : "") : "---",
                partsTools: (el.partsTools !== null && el.partsTools !== "" & el.partsTools !== undefined) ? el.partsTools.substring(0, 30) + (el.partsTools.length > 30 ? "..." : "") : "---",
                estimatedTime:(el.estimatedTime !== null && el.estimatedTime !== "" & el.estimatedTime !== undefined) ? el.estimatedTime.split(":")[0] + " hr " + el.estimatedTime.split(":")[1] + " min" : "---",
                tasks:(el.tasks !== null && el.tasks.length > 0 && el.tasks !== undefined) ? el.tasks.map((eltask,index) => (
                     (index !== el.tasks.length - 1) ? 
                     eltask.taskDescription.concat(",").substring(0, 30) + (eltask.taskDescription.concat(', ').length > 30 ? "..." : "") : 
                     eltask.taskDescription.substring(0, 30) + (eltask.taskDescription.length > 30 ? "..." : "")
                )) : "---"
            }));

            Options_List_Value = Options_List_Value.sort((a, b) => {
                let nameA, nameB;
                
                nameA = a['name'].toLowerCase();
                nameB = b['name'].toLowerCase();
                
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                if (nameA === nameB) {
                    return 0;
                }
                return 0;
            });


            var l_Options_List_Value = Options_List_Value;
            this.setState({ Options_List_Value: l_Options_List_Value }); 
        }
    }


    onSort = (column) => (e) => {
        const SelectedDirectioninfo = this.state.sort.direction.filter(x => x.name == column)[0];
        const direction = SelectedDirectioninfo !== null ? (SelectedDirectioninfo.direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.Options_List_Value;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.state.Options_List_Value.sort((a, b) => {
            var nameA,nameB;
            if(column !== "tasks")
            {
              nameA = a[column];
              nameB = b[column];

               if (isNaN(a[column])) {
                  nameA = a[column].toLowerCase();
                  nameB = b[column].toLowerCase();
               }

            }
            else {
                var a_task = '', b_task = '';
                if(a[column] !== "---"){
                a[column].map((eltask,index) => (
                    a_task = a_task + eltask
                ));
                }
                if(b[column] !== "---"){
                b[column].map((eltask,index) => (
                    b_task = b_task + eltask
                ));
                }

                nameA = a_task;
                nameB = b_task;

                if (isNaN(nameA)) {
                    nameA = nameA.toLowerCase();
                    nameB = nameB.toLowerCase();
                }
                    
            }

           
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(SelectedDirectioninfo.direction == 'asc' && notequals == 1){
        sortedData.reverse();
     }

     const array = this.state.sort.direction;
     array.map(x => (x.name == column) ? x.onclick = true : x.onclick = false);
     array.map(x => (x.name == column) ? x.direction = direction : x.direction = x.direction);

        this.setState({
            Options_List_Value: sortedData,
            sort: {
                column,
                direction: array,
            }
        });
       }
    }

    OpenAddTemplatePopup(templateId){
        this.props.OpenAddTemplatePopup(true,templateId);
    }

    Delete = (someArg) => {
        if (someArg === "yes") {        
            this.props.DeletePMTemplate(this.state.deleteTemplateId);
        }
        this.DeleteToggle();
    }

    DeletePMTemplate(templateId){
        this.setState({
            deleteTemplateId: templateId
        });
        this.DeleteToggle();
    }

    DeleteToggle(){
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    }
    
    render(){
        let label = this.props.getLabels;
        var IsNotEmpty = false;
        if(this.state.Options_List_Value !== undefined && this.state.Options_List_Value !== null && this.state.Options_List_Value.length > 0)
        { 
            IsNotEmpty = true;
        }        
        return(
            <div style={{marginTop:'30px'}}>
                <Form>
                    <FormGroup>
                        <Label style={headinglabel}>{label['WorkOrderSetup.Templates.Text'] !== undefined ? label['WorkOrderSetup.Templates.Text'] : "Preventative Maintenance Templates"}</Label>
                        <Button id="btn_templatesetup_create" style={{'float':'right'}} className="child_tab_button" onClick={() => { this.OpenAddTemplatePopup(-1) }}>{label['WorkOrderSetup.Template.Button.Text'] !== undefined ? label['WorkOrderSetup.Template.Button.Text'] : "CREATE MAINTENANCE TEMPLATE"}</Button>
                    </FormGroup>
                </Form>
                {
                    !IsNotEmpty ?
                        <div className="table_container table_border">
                            <Table striped responsive className="Custom_table fixed_layout">
                                <tbody className="cell_container">
                                    <tr>
                                        <th><span>{label['WorkOrderSetup.Header.name.Text'] !== undefined ? label['WorkOrderSetup.Header.name.Text'] : "NAME"}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.estimatedTime.Text'] !== undefined ? label['WorkOrderSetup.Header.estimatedTime.Text'] : "ESTIMATED TIME"}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.description.Text'] !== undefined ? label['WorkOrderSetup.Header.description.Text'] : "DESCRIPTION"}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.partstools.Text'] !== undefined ? label['WorkOrderSetup.Header.partstools.Text'] : "PARTS AND TOOLS"}</span></th>
                                        <th><span>{label['WorkOrderSetup.Header.tasklist.Text'] !== undefined ? label['WorkOrderSetup.Header.tasklist.Text'] : "TASK LIST"}</span></th>
                                    </tr>
                                    <tr><td colSpan="5">{label['WorkOrders.Table.Default.Text']}</td></tr>
                                </tbody>
                            </Table>
                        </div> :
                        <div className="table_container table_border">
                                <table className="Custom_table fixed_layout table table-striped" style={{tableLayout:'auto'}}>
                                    <thead className="cell_container">
                                        <tr>
                                        <th className="wo_cursor" onClick={this.onSort('name')}><span>{label['WorkOrderSetup.Header.name.Text'] !== undefined ? label['WorkOrderSetup.Header.name.Text'] : "NAME"}</span>
                                        <span className={(this.state.sort.direction[0].name == "name") ?
                                                (this.state.sort.direction[0].onclick) ? (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[0].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                       </span>
                                        </th>
                                        <th className="wo_cursor" onClick={this.onSort('estimatedTime')}><span>{label['WorkOrderSetup.Header.estimatedTime.Text'] !== undefined ? label['WorkOrderSetup.Header.estimatedTime.Text'] : "ESTIMATED TIME"}</span>
                                        <span className={(this.state.sort.direction[1].name == "estimatedTime") ?
                                                (this.state.sort.direction[1].onclick) ? (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[1].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                        </th>
                                        <th className="wo_cursor" onClick={this.onSort('description')}><span>{label['WorkOrderSetup.Header.description.Text'] !== undefined ? label['WorkOrderSetup.Header.description.Text'] : "DESCRIPTION"}</span>
                                        <span className={(this.state.sort.direction[2].name == "description") ?
                                                (this.state.sort.direction[2].onclick) ? (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[2].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                        </th>
                                        <th className="wo_cursor" onClick={this.onSort('partsTools')}><span>{label['WorkOrderSetup.Header.partstools.Text'] !== undefined ? label['WorkOrderSetup.Header.partstools.Text'] : "PARTS AND TOOLS"}</span>
                                        <span className={(this.state.sort.direction[3].name == "partsTools") ?
                                                (this.state.sort.direction[3].onclick) ? (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[3].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                        </th>
                                        <th className="wo_cursor" onClick={this.onSort('tasks')}><span>{label['WorkOrderSetup.Header.tasklist.Text'] !== undefined ? label['WorkOrderSetup.Header.tasklist.Text'] : "TASK LIST"}</span>
                                        <span className={(this.state.sort.direction[4].name == "tasks") ?
                                                (this.state.sort.direction[4].onclick) ? (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction asccolor" : "workorder-sort-direction desccolor"
                                                    : (this.state.sort.direction[4].direction == "asc") ? "workorder-sort-direction desc" : "workorder-sort-direction desc" : "workorder-sort-direction desc"}>
                                        </span>
                                        </th>
                                        <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className="cell_container">
                                                    {this.state.Options_List_Value.map((entity, index) => (
                                                      
                                                                    <tr>
                                                                        <td className="link_cursorUnderline" onClick={() => { this.OpenAddTemplatePopup(entity.templateId) }}>{entity.name}</td>
                                                                        <td>{entity.estimatedTime}</td>
                                                                        <td>{entity.description}</td>
                                                                        <td>{entity.partsTools}</td>
                                                                        <td>{entity.tasks}</td>
                                                                        <td style={{cursor:'pointer'}}><img src={DeleteIcon} style={{ width: '18px', float: 'right', valign: 'bottom', marginRight: '15px' }} className="link_cursor" alt="DeleteIcon" onClick={() => {this.DeletePMTemplate(entity.templateId)}}/></td>
                                                                    </tr>
                                                               
                                                    ))}
                                     </tbody>
                                </table>
                        </div>
                }
                <Modal isOpen={this.state.deleteModal} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")} >
                    <DeleteConfirmation parentToChildData={["Delete Preventative Maintenance Template", "You are about to delete a Maintenance Template from the system. This Maintenance Template might be associated to existing PM. Do you want to continue? "]} Delete={this.Delete} />
                </Modal>
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return{
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getTemplates: state.WorkorderRootReducer.PreventativeMaintenanceTemplates
    }
};

const mapDispatchToProps = (dispatch) => {
    return{
        GetPreventativeMaintenanceTemplates : () => dispatch(GetPreventativeMaintenanceTemplates()),
        OpenAddTemplatePopup: (data,templateId) => dispatch(OpenAddTemplatePopup(data,templateId)),
        DeletePMTemplate: (templateId) => dispatch(DeletePMTemplate(templateId)),
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(PreventativeMaintenanceTemplates);